export default {
  manage_createEditKeyFob_EditTitle: "Editar Llavero",
  manage_createEditKeyFob_CreateTitle: "Crear nuevo Llavero",
  manage_createEditKeyFob_success: "Llavero fue creado exitosamente",
  manage_createEditKeyFob_success_edit: "Llavero fue editado exitosamente",
  manage_createEditKeyFob_HexInputLabel: "Llavero",
  manage_createEditKeyFob_HexInputPlaceholder: "Llavero",
  manage_createEditKeyFob_DriverInputLabel: "Conductor",
  manage_createEditKeyFob_DriverInputPlaceholder: "Conductor",
  manage_createEditKeyFob_duplicatedKeyFobErrorMessage: "Este Llavero ya existe o el conductor ya tiene un llavero asignado",
  manage_createEditKeyFob_infoBluetooth: "Los IDs de los llaveros Bluetooth de Geometris no se pueden editar"
};